import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/orderClassificationTypes', request)
}

export {get}
